/**
 * @desc 组件类型枚举
 */
export var ComponentConfigType;
(function (ComponentConfigType) {
    /** 常用 */
    ComponentConfigType["COMMONLY_USED"] = "commonlyUsed";
    /** 表单项 */
    ComponentConfigType["FORM_ITEM"] = "formItem";
    /** 容器 */
    ComponentConfigType["CONTAINER"] = "container";
    /** 反馈 */
    ComponentConfigType["FEED_BACK"] = "feedBack";
    /** 数据展示 */
    ComponentConfigType["DEMONSTRATION"] = "demonstration";
    /** 导航 */
    ComponentConfigType["NAV"] = "nav";
})(ComponentConfigType || (ComponentConfigType = {}));
//# sourceMappingURL=materialsConfig.js.map